<div class="card">
  <app-environment-info [currentEnvironment]="currentEnvironment"></app-environment-info>
  <div class="card-body p-3">
    <h2>Add new peer to the network</h2>
    <p>Select and add an environment as a peer to be able to create an NCache Bridge link for WAN replication over regions.</p>

    <form [formGroup]="peeringForm" (submit)="onSubmit()">

      <!-- Customized Select Box for Env Selection -->
      <div class="mb-3">
        <label for="envName" class="form-label">Environment Name</label>
        <div>
          <div class="dropdown">
            <button class="btn btn-secondary dropdown-toggle d-flex justify-content-between align-items-center"
              type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
              {{ environments.length === 0 || !peeringForm.get('envName').value ? 'Select an environment to pair' :
              peeringForm.get('envName').value + ' (' + (selectedEnv ? selectedEnv.type : '') + ')' }}
            </button>

            <!-- Dropdown menu -->
            <ul class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton">
              <!-- Environments List -->
              <li *ngIf="environments.length > 0; else noEnvironments">
                <ng-container *ngFor="let environment of environments">
                  <li class="dropdown-item" (click)="selectEnvironment(environment.name)">
                    <div class="d-flex flex-column align-items-start drop-item-parent">
                      <p class="fw-bold">{{ environment.name }} ({{ environment.type }})</p>
                      <p>{{ environment.region }}</p>
                      <p>{{ environment.os }}</p>
                      <p>{{ environment.serverProfile }}</p>
                    </div>
                  </li>
                </ng-container>
              </li>
              <!-- No Environments Message -->
              <ng-template #noEnvironments>
                <li style="cursor: default;" class="d-flex justify-content-center align-items-center w-100 h-100 py-3">No environment found to peer</li>
              </ng-template>
            </ul>

          </div>
          <input type="hidden" formControlName="envName" id="envName">
        </div>
      </div>

      <!-- Add Btn -->
      <div class="mt-2">
        <button type="submit" class="btn btn-primary w-100 btn-sm" [disabled]="this.environments.length === 0" [style.cursor]="this.environments.length === 0 ? 'default' : 'pointer'">
          Add<i class="fa fa-plus fa-xs ms-2"></i>
        </button>
      </div>

    </form>

  </div>
</div>